import React from 'react';
import StandaloneShell from '../../components/StandaloneShell';
import PermissionGate from '../../components/PermissionGate';
import { ToastProvider } from '../../components/Toast';
import HR from '../HR';

export default function HRPage() {
  const token = localStorage.getItem('token');
  return (
    <StandaloneShell title="HR">
      {({ darkMode, T }) => (
        <PermissionGate module="hr" moduleName="HR">
          <ToastProvider>
            <HR token={token} darkMode={darkMode} T={T} />
          </ToastProvider>
        </PermissionGate>
      )}
    </StandaloneShell>
  );
}
